<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Создать зону
            </div>

            <div class="subtitle-1 font-weight-light">
              Заполните поля информацией о ресторане
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    :error-messages="errors['title'] || []"
                    class="purple-input"
                    v-model="data.title"
                    label="Название"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    :error-messages="errors['avgSpentTime'] || []"
                    v-model="data.avgSpentTime"
                    class="without_ampm"
                    label="Среднее время длятельности брони"
                    value="02:30"
                    type="time"
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    :error-messages="errors['availableReserveBeforeTime'] || []"
                    v-model="data.availableReserveBeforeTime"
                    class="without_ampm"
                    label="За сколько, до начала брони, можно создать резерв"
                    value="02:30"
                    type="time"
                    format="hh:mm"
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="success"
                    class="mr-0"
                    v-if="!loadData"
                    :loading="loading"
                    @click="create"
                  >
                    Сохранить
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <base-material-card
          class="v-card-profile"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{ user }}
            </div>
          </template>
          <v-card-text class="text-center">
            <v-switch v-model="data.isActive" label="Доступно бронирование"></v-switch>
          </v-card-text>
          <v-card-text class="text-center">
            <v-text-field
              label="Порядок сортировки"
              type="number"
              :error-messages="errors['sort_order'] || []"
              class="purple-input"
              v-model="data.sortOrder"
            />
          </v-card-text>
        </base-material-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
  import store from "../../../../store/store";

  export default {
    props:{
      id: {
        type : [Number, String],
        default : null
      },
      restaurantId : {
        type : [Number, String],
      }
    },
    created() {
      if(this.id){
        this.loadData = true;
        bus.$emit('onProgressLinear');
        this.$store.dispatch('restaurantZones/getZone', {
          id: this.id,
          restaurantId: this.restaurantId
        })
          .then(({data}) => {
            this.loadData = false;
            this.data.id = this.id;
            this.data.title = data.title;
            this.data.avgSpentTime = data.avgSpentTime;
            this.data.availableReserveBeforeTime = data.availableReserveBeforeTime;
            this.data.sortOrder = data.sortOrder;
            this.data.isActive = data.isActive;
            bus.$emit('offProgressLinear');
          })
      }
    },
    data(){
      return {
        loadData: false,
        errors: [],
        loading: false,
        data : {
          id: null,
          title : '',
          avgSpentTime : '',
          availableReserveBeforeTime : '',
          sortOrder  : '',
          isActive: '',
          restaurantId : this.restaurantId
        },
      }
    },
    computed: {
      user() {
        return this.$store.getters['auth/loggedIn'].data.fullName;
      }
    },
    methods:{
      create(){
        this.errors = [];

        if(this.loading){
          return;
        }

        this.loading = true;

        this.$store.dispatch('restaurantZones/createZone',this.data)
          .then(({data}) => {
            this.$router.push({'name' : 'RestaurantZoneEdit', params : {id : data.id, restaurantId : data.restaurantId}}).catch(()=>{});
            setTimeout(() => {
              this.loading = false;
            }, 1500)
          })
          .catch(error => {
            this.loading = false;
            let response = error.response

            if(response.status == 422){
              this.errors = response.data.errors;
            }
          })
      }
    }
  }
</script>

<style>
  .without_ampm::-webkit-datetime-edit-ampm-field {
    display: none;
  }
  input[type=time]::-webkit-clear-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    -ms-appearance:none;
    appearance: none;
    margin: -10px;
  }
</style>
